import { url } from '../static/env';

export async function fetchBuhServiceStatus(userId) {
    const response = await fetch(`${url}/buh-service-status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.error || 'Не удалось получить статус обслуживания');
    }
    return data;
}
